(function ($) {
    const $form = $('#products-form');

    if ($form.length === 0) {
        return;
    }

    const subPreparationsUrl = $form.data('ajax-url-sub_preparations');
    const offersUrl = $form.data('ajax-url-offers');
    const $subPreparations = $('#selected_sub_preparations');
    const $offers = $('#selected_offers');

    const loadSubpreparations = (schoolYearId, brandId) => {
        const url = subPreparationsUrl + '/' + brandId + '/' + schoolYearId;
        $subPreparations.load(url, () => {
            $('#sub_preparation_id').change(function () {
                const subPreparationId = $(this).val();
                $offers.load(`${offersUrl}/${subPreparationId}`);
            });
        });
    };

    const handleSubpreparationSelector = () => {
        $('#brand_id, #school_year_id').change(function () {
            const schoolYearId = $('#school_year_id').val();
            const brandId = $('#brand_id').val();

            if (brandId === '' || schoolYearId === '') {
                return;
            }

            loadSubpreparations(schoolYearId, brandId);
        });
    };

    const handleOfferCheckBoxes = () => {
        document.addEventListener('change', function (e) {
            const target = e.target;
            if (target.type !== 'checkbox') {
                return;
            }
            const $subPreparationsSelector = $('#sub_preparation_id');
            const $productSelector = $('#product_id');
            const stageIds = [];
            const subPreparationId = $subPreparationsSelector.val();
            const productId = $productSelector.length ? $productSelector.val() : null;
            $('input:checkbox[name=stage]:checked').each(function () {
                stageIds.push($(this).val());
            })
            $offers.load(`${offersUrl}/${subPreparationId}?productId=${productId}&stageIds=${stageIds.join('|')}`);
        });
    };

    handleSubpreparationSelector();
    handleOfferCheckBoxes();

})($);